// PERFORMANCE OPTIMIZATION ADDED - Code splitting with React.lazy for better bundle size
import React, { lazy } from "react";

// PERFORMANCE OPTIMIZATION ADDED - Lazy load all protected page components to reduce initial bundle size
const Order = lazy(() => import("../pages/Order"));
const Cart = lazy(() => import("../pages/Cart"));
const Checkout = lazy(() => import("../pages/Checkout"));
const AdminUsers = lazy(() => import("../pages/AdminUsers"));
const AdminDashboard = lazy(() => import("../pages/AdminDashboard"));
const AdminProducts = lazy(() => import("../pages/AdminProducts"));
const AdminProductForm = lazy(() => import("../pages/AdminProductForm"));
const AdminOrders = lazy(() => import("../pages/AdminOrders"));
const AdminQueries = lazy(() => import("../pages/AdminQueries"));
const AdminNotifyMe = lazy(() => import("../pages/AdminNotifyMe"));
const Profile = lazy(() => import("../pages/Profile"));
const OrderHistory = lazy(() => import("../pages/OrderHistory"));
const ShippingAddressPage = lazy(() => import("../pages/ShippingAddressPage"));

export interface ProtectedRouteConfig {
  path: string;
  element: React.ReactElement;
  allowedRoles: ("user" | "admin")[];
}

export const protectedRoutes: ProtectedRouteConfig[] = [
  { path: "/profile", element: <Profile />, allowedRoles: ["user"] },
  { path: "/order", element: <Order />, allowedRoles: ["user"] },
  { path: "/orders", element: <OrderHistory />, allowedRoles: ["user", "admin"] },
  { path: "/cart", element: <Cart />, allowedRoles: ["user"] },
  { path: "/checkout", element: <Checkout />, allowedRoles: ["user"] },
  { path: "/shipping-address", element: <ShippingAddressPage />, allowedRoles: ["user"] },
  { path: "/shipping-address/:addressId", element: <ShippingAddressPage />, allowedRoles: ["user"] },
  { path: "/admin/dashboard", element: <AdminDashboard />, allowedRoles: ["admin"] },
  { path: "/admin/users", element: <AdminUsers />, allowedRoles: ["admin"] },
  { path: "/admin/products", element: <AdminProducts />, allowedRoles: ["admin"] },
  { path: "/admin/products/new", element: <AdminProductForm />, allowedRoles: ["admin"] },
  { path: "/admin/products/:id/edit", element: <AdminProductForm />, allowedRoles: ["admin"] },
  { path: "/admin/orders", element: <AdminOrders />, allowedRoles: ["admin"] },
  { path: "/admin/queries", element: <AdminQueries />, allowedRoles: ["admin"] },
  { path: "/admin/notify-me", element: <AdminNotifyMe />, allowedRoles: ["admin"] },
];


